import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onBeforeUnmount, onMounted, ref } from 'vue';
import { usePageToolbar } from '@/core/hooks/usePageToolbar';

/**
 * Teleports page-specific filter controls into the header "Bộ lọc" dropdown.
 * Mount this with non-search filters; use usePageHeader({ showSearch: true }) for search.
 *
 * Wrapped in el-form so shared inputs that use el-form-item
 * (e.g. DanhMucToaXeSearchInput) get a valid form context.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'PageHeaderFilters',
  setup(__props) {

const { registerFilterPanel } = usePageToolbar();
const targetReady = ref(false);
let rafId = 0;

function waitForSlot() {
  if (document.getElementById('page-toolbar-filters-slot')) {
    targetReady.value = true;
    return;
  }
  rafId = requestAnimationFrame(waitForSlot);
}

onMounted(() => {
  registerFilterPanel(true);
  waitForSlot();
});

onBeforeUnmount(() => {
  targetReady.value = false;
  if (rafId) {
    cancelAnimationFrame(rafId);
  }
  registerFilterPanel(false);
});

return (_ctx: any,_cache: any) => {
  const _component_el_form = _resolveComponent("el-form")!

  return (targetReady.value)
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "#page-toolbar-filters-slot"
      }, [
        _createVNode(_component_el_form, {
          class: "page-header-filters",
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        })
      ]))
    : _createCommentVNode("", true)
}
}

})